import type {
  PartnerProductDtoSinglePartnerProductView,
  PartnerProductDtoSlicedPartnerProductView,
} from '@bldsoft/cappie/api/wbs'
import type {
  PartnerProduct,
  PartnerProductDetails,
  PurchaseInfo,
} from '@setplex/tria-api'

import {
  MediaTypes,
  PriceSettingsType,
  PurchaseInfoContentPurchaseType as PurchaseInfoContentPurchaseTypeEnum,
} from '@setplex/tria-api'
import { getBackgroundImage, getHorizontalImage } from '../../utils/images'
import { formatPriceSettings } from '../../utils/payment'

export const formatPartnerProduct = ({
  id,
  coverImageUrl,
  free,
  priceSettings,
  purchaseInfo,
  ...rest
}: PartnerProductDtoSlicedPartnerProductView): PartnerProduct => {
  return {
    ...rest,
    id: id as number,
    coverImageUrl: getHorizontalImage(coverImageUrl),
    mediaType: MediaTypes.PARTNER_PRODUCT,
    free: free === undefined ? true : free,
    priceSettings: formatPriceSettings(priceSettings),
    purchaseInfo: purchaseInfo as PurchaseInfo | undefined,
    rented:
      purchaseInfo?.contentPurchaseType ===
      PurchaseInfoContentPurchaseTypeEnum.Rented,
  }
}

export const formatPartnerProductDetails = ({
  id,
  coverImageUrl,
  // verticalImageUrl,
  purchaseInfo,
  priceSettings,
  free,
  name,
  ...rest
}: PartnerProductDtoSinglePartnerProductView): PartnerProductDetails => {
  return {
    ...rest,
    id: id as number,
    name: name as string,
    coverImageUrl: getBackgroundImage(coverImageUrl),
    // imageMobileBackgroundUrl: getBackgroundImage(verticalImageUrl),
    mediaType: MediaTypes.PARTNER_PRODUCT,
    free: free === undefined ? true : free,
    purchaseInfo: purchaseInfo as PurchaseInfo | undefined,
    priceSettings: formatPriceSettings(priceSettings),
    priceType: PriceSettingsType.Rent,
    rented:
      purchaseInfo?.contentPurchaseType ===
      PurchaseInfoContentPurchaseTypeEnum.Rented,
  }
}
